import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdClear } from 'react-icons/md';

const Clear: React.FC<IconBaseProps> = (props) => <MdClear {...props} />;

export default Clear;
